import { useMediaQuery } from "react-responsive";

import { OffcanvasProvider } from "@/components/context/OffcanvasContext";

import DesktopNavbar from "./components/DesktopNavbar";
import Menu from "./components/Menu";
import MobileNavbar from "./components/MobileNavbar";

function Sidebar() {
  const isDesktop = useMediaQuery({ minWidth: 1025 });

  return (
    <>
      <OffcanvasProvider>
        {isDesktop ? (
          <DesktopNavbar menu={<Menu />} />
        ) : (
          <MobileNavbar menu={<Menu />} />
        )}
      </OffcanvasProvider>
    </>
  );
}

export default Sidebar;
